import { Component, inject, input, computed } from "@angular/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { WkDataTableInputTypeEnum } from "@components/data-table/data-table.types";
import { WkDataTableContextService } from "@components/data-table/data-table-context.service";
import { WkDataTableStoreService } from "@components/data-table/store";
import { WkDataTableItemsService } from "@components/data-table/data-table.components";
import { WkOverflowTooltipDirective } from "@shared/directives";
import { SafeHtml } from "@angular/platform-browser";

@Component({
    selector: "td[wk-data-table-cell]",
    templateUrl: "./data-table-cell.component.html",
    styleUrls: ["./data-table-cell.component.scss", "../data-table-cell.scss"],
    host: {
        class: "wk-data-table__cell",
        "[style.width.px]": "width()",
        "[class.wk-data-table__cell--locked]": "locked()",
        "[style.left.px]": "lockedPosition()",
        "[id]": '"wk-data-table__cell-" + column()?.fullFieldName()',
    },
    imports: [JumpstartComponentsModule, WkOverflowTooltipDirective],
    hostDirectives: [
        {
            directive: WkOverflowTooltipDirective,
            inputs: ["wkOverflowTooltipTarget"],
        },
    ],
})
export class WkDataTableCell<TItem> {
    private readonly dataTableStore = inject(WkDataTableStoreService);
    private readonly dataTableItems = inject<WkDataTableItemsService<TItem>>(WkDataTableItemsService);
    private readonly dataTableContext = inject<WkDataTableContextService<TItem>>(WkDataTableContextService);

    protected readonly InputTypeEnum = WkDataTableInputTypeEnum;
    protected readonly wkOverflowTooltipTarget = ".wk-data-table__cell__value";

    public index = input.required<number>();
    public columnIndex = input.required<number>();
    public fieldname = input.required<string>();

    protected readonly item = computed(() => this.dataTableItems.getItem(this.index()));
    protected readonly column = computed(() => this.dataTableStore.get(this.fieldname()));
    protected readonly width = computed(() => this.column()?.definition.width ?? 170);
    protected locked = computed(() => this.column()?.definition.locked ?? false);
    protected lockedPosition = computed(() => {
        const locked = this.locked();
        const index = this.columnIndex();
        const columns = this.dataTableStore.lockedColumns();
        const selectable = this.dataTableContext.selectable();
        if (!locked) return 0;
        const lockedColumns = columns.filter((_, colIndex) => colIndex < index);
        let position = selectable ? 48 : 0;
        lockedColumns.forEach((col) => {
            position += col.definition.width ?? 170;
        });
        return position;
    });
    protected value = computed<SafeHtml | string>(() => {
        const item = this.item();
        const column = this.column();
        const value = !item ? "" : (column?.getValue?.()?.(item?.value) ?? "");
        return value;
    });
}
